export default __webpack_public_path__ + "static/media/doctor.c7adbc7e.jpeg";